import React, { FCC } from 'react'

// Icon
import { ReactComponent as Templates } from '@sketch/icons/templates-46'

import { Container, Title, Description } from './EmptyState.styles'

export interface EmptyStateProps {
  workspaceName: string
  className?: string
}

const EmptyState: FCC<EmptyStateProps> = ({ workspaceName, className }) => {
  return (
    <Container className={className}>
      <Templates width={46} />
      <>
        <Title>No published documents</Title>
        <Description>
          {workspaceName} hasn’t added anything to their public profile yet.
        </Description>
      </>
    </Container>
  )
}

export default EmptyState
